import type { ExtensionConfig } from '@goto/shell'

const extensionConfig: ExtensionConfig = {
  id: '@ucc/omni-inbox',
  url: new URL('/experiences/inbox/@ucc/omni-inbox-extension.mjs', location.origin),
  esModule: true,
}

export default extensionConfig
